var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":""},on:{"click":_vm.logOut}},[_c('span',{class:_vm.buttonClass},[_vm._v("Logout")]),_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._v(" mdi-logout ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }